import { useCallback, useEffect } from 'react';
import { useFetch } from '../common/useFetch';
import { useEmitMessage } from '../common/useEmitMessage';
import { SubscriptionState, Subscription } from '../App/useSubscription';

/**
 * サブスクの停止・停止解除を担う
 */
export const useSubscriptionPause = (
  subscription: SubscriptionState,
  setSubscription: Function,
  token: string
) => {

  const emitMessage = useEmitMessage();
  const success = () => emitMessage('app-complete');
  const failed = () => emitMessage('app-error', 'keep');

  const [state, callPauseSubscription] 
    = useFetch<Subscription>('updateSubscription', token, success, failed);

  // 一時停止を行う
  const pauseSubscription = useCallback(() => {
    if (!subscription) return;

    const param: PauseSubscriptionParam = {
      subscriptionId: subscription.subscriptionContractId,
      status: 'paused'
    };

    callPauseSubscription(param);

  }, [subscription]);

  // 一時停止の解除(stateをactiveに変更)を行う
  const pauseCancelSubscription = useCallback(() => {
    if (!subscription) return;

    const param: PauseSubscriptionParam = {
      subscriptionId: subscription.subscriptionContractId,
      status: 'active'
    };

    callPauseSubscription(param);

  }, [subscription]);

  // 通信開始・完了時ハンドリング
  useEffect(() => {
    if (state.loading === true)
      emitMessage('app-updating', 'keep');
    if (state.data) 
      setSubscription({
        ...subscription,
        status: state.data.status
      });
  }, [state.loading, state.data, setSubscription]);

  return [
    state.loading,
    {
      pauseSubscription,
      pauseCancelSubscription
    }
  ] as [
    boolean,
    { 
      pauseSubscription: () => void,
      pauseCancelSubscription: () => void
    }
  ];
}

export type PauseSubscriptionParam = {
  subscriptionId: string,
  status: 'paused' | 'active',
}